import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import ContractsForm from "../components/contracts/ContractsForm";

const ContractsFormAddorEdit = () => (
 <Container fluid className="main-content-container px-4 pb-4">
    {/* Page Header */}
    <Row noGutters className="page-header pt-4">
      <PageTitle sm="4" title="Contrato" className="text-sm-left" />
    </Row>

    <Row>
      <Col md="12">
        <ContractsForm />
      </Col>
    </Row>
  </Container>
);

export default ContractsFormAddorEdit;
